import { CrudForm } from "#pub/crud/index.js";
import MessageFormConfig from "./config/MessageFormConfig.js";

export default {

    extends: CrudForm,

    name: 'MessageForm',

    config: MessageFormConfig,
}